"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagLink = exports.StyledLink = void 0;
var react_1 = __importDefault(require("react"));
var Tag_1 = require("../Tag");
var styled_components_1 = __importDefault(require("styled-components"));
var react_router_dom_1 = require("react-router-dom");
exports.StyledLink = (0, styled_components_1.default)(react_router_dom_1.NavLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-decoration: none;\n"], ["\n  text-decoration: none;\n"])));
var TagLink = function (_a) {
    var display = _a.display, to = _a.to, id = _a.id, fill = _a.fill, size = _a.size, weight = _a.weight;
    return (react_1.default.createElement(exports.StyledLink, { to: to },
        react_1.default.createElement(Tag_1.Tag, { id: id, display: display, icon: "ArrowLineUpRight", size: size || "S", variant: "link", fill: fill, weight: weight })));
};
exports.TagLink = TagLink;
var templateObject_1;
